import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth, createUserWithEmailAndPassword, updateProfile, User } from '@angular/fire/auth';
import { Firestore, collectionData, collection, addDoc, doc, updateDoc, query, where, getDocs, getDoc, setDoc, DocumentSnapshot, DocumentData } from '@angular/fire/firestore';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import * as moment from 'moment';
import { forkJoin, merge, Observable, Subject } from 'rxjs';
import { IUser } from 'src/app/model/user';

@Injectable({
    providedIn: 'root'
})
export class SettingService {

    constructor(public firestore: Firestore, private http: HttpClient) { }


    /**
     * 
     * @returns 
     */
    public settingRegistration(): Observable<{disabled:boolean}[]> {
        return collectionData(collection(this.firestore, `/setting`)) as Observable<{disabled:boolean}[]>;

    }

      /**
     * 
     * @returns 
     */
      public settingZoom() {
        return collectionData(collection(this.firestore, `/setting`));

    }
}
